import { Button, Card, Paper, Stack, Text } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { useApplicationContext } from '@/providers/ApplicationContext'
import { RouterPath } from '@/router/paths'
import { AppNavLinks } from './AppNavLinks'

export const AppDetailsSidebar = () => {
  const { application } = useApplicationContext()

  if (!application) {
    return null
  }

  return (
    <Paper p={8}>
      <Stack gap="lg">
        <Button
          variant="outline"
          size="xs"
          leftSection={<IconArrowLeft size={16} />}
          component={Link}
          to={RouterPath.apps}
        >
          <FormattedMessage id="apps.backToApps" />
        </Button>

        <Card bg="gray.0">
          <Text size="md" fw={600}>
            {application.name}
          </Text>
        </Card>

        <AppNavLinks appId={application.id} />
      </Stack>
    </Paper>
  )
}
